import { motion } from "framer-motion";
import { Check, Sparkles } from "lucide-react";
import { Reveal, Overline } from "./Reveal";
import { PACKAGE } from "../lib/content";
import { PaymentButtons } from "./PaymentButtons";

export const Signature = ({ onConsult }) => (
  <section
    id="package"
    className="relative bg-[#1a1410] py-24 sm:py-36 scroll-mt-20 overflow-hidden"
  >
    <div className="absolute inset-0 bg-[radial-gradient(circle_at_50%_0%,rgba(212,175,55,0.1),transparent_60%)]" />
    <div className="relative mx-auto max-w-[1100px] px-5 sm:px-8">
      <div className="text-center max-w-2xl mx-auto">
        <Reveal>
          <div className="flex justify-center">
            <Overline>Our Signature Service</Overline>
          </div>
        </Reveal>
        <Reveal delay={0.05}>
          <h2 className="mt-6 font-serif font-bold tracking-tight text-white text-3xl sm:text-4xl lg:text-5xl">
            The Entrepreneur <span className="text-gold-foil">Launch Package</span>
          </h2>
        </Reveal>
        <Reveal delay={0.1}>
          <p className="mt-5 text-zinc-400 font-light text-lg">{PACKAGE.tagline}</p>
        </Reveal>
      </div>

      <Reveal delay={0.12}>
        <div className="mt-14 relative">
          <div className="absolute -inset-px bg-gold-foil opacity-60 blur-[2px]" />
          <div className="relative bg-[#262019] border border-amber-500/30 p-8 sm:p-12">
            <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-6 pb-8 border-b border-amber-500/15">
              <div>
                <span className="inline-flex items-center gap-2 text-[11px] uppercase tracking-[0.2em] text-amber-500">
                  <Sparkles className="h-4 w-4" /> All-in-One Startup Kit
                </span>
                <h3 className="mt-3 font-serif text-2xl sm:text-3xl text-white">
                  {PACKAGE.name}
                </h3>
              </div>
              <div className="text-left sm:text-right">
                <div className="font-serif text-6xl sm:text-7xl font-black text-gold-foil leading-none">
                  {PACKAGE.price}
                </div>
                <p className="text-xs text-zinc-500 mt-1 uppercase tracking-wide">
                  One-time launch investment
                </p>
              </div>
            </div>

            <div className="mt-8 grid sm:grid-cols-2 gap-x-10 gap-y-4">
              {PACKAGE.includes.map((item, i) => (
                <motion.div
                  key={item}
                  initial={{ opacity: 0, x: -15 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.5, delay: i * 0.04 }}
                  className="flex items-start gap-3"
                >
                  <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-amber-500/15">
                    <Check className="h-3 w-3 text-amber-400" />
                  </span>
                  <span className="text-[15px] text-zinc-200">{item}</span>
                </motion.div>
              ))}
            </div>

            <div className="mt-10 pt-8 border-t border-amber-500/15 flex flex-col lg:flex-row lg:items-center lg:justify-between gap-8">
              <div>
                <p className="text-xs uppercase tracking-[0.2em] text-amber-500 mb-3">
                  Perfect For
                </p>
                <div className="flex flex-wrap gap-2">
                  {PACKAGE.perfectFor.map((p) => (
                    <span
                      key={p}
                      className="text-xs text-zinc-300 border border-zinc-700 px-3 py-1.5 rounded-full"
                    >
                      {p}
                    </span>
                  ))}
                </div>
              </div>
              <div className="w-full lg:w-[380px] shrink-0">
                <PaymentButtons
                  total={PACKAGE.purchase.total}
                  fullKey={PACKAGE.purchase.fullKey}
                  installmentKey={PACKAGE.purchase.installmentKey}
                  installmentAmount={PACKAGE.purchase.installmentAmount}
                  installment3Key={PACKAGE.purchase.installment3Key}
                  installment3Amount={PACKAGE.purchase.installment3Amount}
                  testid="package"
                />
                <button
                  onClick={onConsult}
                  data-testid="package-cta-btn"
                  className="mt-4 w-full text-center text-[12px] font-bold uppercase tracking-[0.14em] text-amber-400 hover:text-amber-200 transition-colors"
                >
                  Or Book a Free 15-Minute Consultation
                </button>
              </div>
            </div>
          </div>
        </div>
      </Reveal>
    </div>
  </section>
);
